import { sharedReducer, SharedState } from './Shared/reducer';
import { combineReducers, Reducer } from "redux";
// import { connectRouter } from 'connected-react-router';
// import { history } from "./middleware";
import { customerPortalReducer, CustomerPortalState } from './CustomerPortal/reducer';
import {curatedVehiclesReducer, CuratedVehicleState} from "./CuratedVehicles/reducer";

export interface AppState {
  shared: SharedState;
  customerPortal: CustomerPortalState;
  curatedVehicles: CuratedVehicleState;
  // router: any;
}

export const rootReducer = combineReducers({
  shared: sharedReducer,
  customerPortal: customerPortalReducer,
  curatedVehicles: curatedVehiclesReducer
  // router: connectRouter(history),
});